import React from "react";
import classNames from "classnames";

import MultilineText from "../../MultilineText";
import Address from "../../Address";
import DisplayField from "../DisplayField";
import styles from "./BidEvent.css";
import ActionButtons from "./ActionButtons";
import Details from "./Details";

const makeStyle = ({ color }) =>
  !color
    ? null
    : {
        borderColor: color,
      };

const BidEvent = ({
  className,
  detailEnabled,
  entity,
  event,
  locationEnabled,
  onClick,
  onOpenClick,
  showActions,
  styleSelector,
}) => (
  <div
    className={classNames(className || styles.container, styles.tentative, {
      [styles.inactive]: entity !== "bids",
    })}
  >
    <div onDoubleClick={onClick}>
      <div
        style={
          typeof styleSelector === "function"
            ? styleSelector(event)
            : makeStyle(event)
        }
      >
        <h5
          style={{
            textAlign: "left",
            padding: "6px 8px",
            fontSize: "16px",
            fontFamily: "var(--font-family-Fira-Condensed)",
          }}
        >
          <b>{event.bid.name}</b>
        </h5>
      </div>
      <div className={styles.bidEventHeader}>
        {detailEnabled && (
          <DisplayField group="details" field="description">
            <MultilineText text={event.description} />
          </DisplayField>
        )}

        {detailEnabled && <Details event={event} />}

        {locationEnabled && (
          <Address
            address={event.bid.address}
            className={styles.address}
            styles={styles}
            multiline
          />
        )}
      </div>
    </div>
    {showActions && <ActionButtons onOpenClick={onOpenClick} />}
  </div>
);

BidEvent.defaultProps = {
  showActions: true,
};

export default BidEvent;
